import { PaperPlaneTiltIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'components/form/formik';
import { Card } from 'components/Card';
import { useTranslation } from 'contexts/translation-context';
import * as Yup from 'yup';
import { useState } from 'react';

import { Button } from '../../../../components/button/Button';
import { useSupplier } from '../Supplier/supplierContext';
import { InputField } from '../../../../components/input/InputField';
import { ISimpleSelectItem, SimpleSelect } from '../../../../components/select/SimpleSelect';
import { getDisplayError } from '../../../../utils/get-display-error';
import { inviteCarrierUser } from '../../models';
import { captureException } from '@sentry/react';
import { trackEvent } from '../../../../utils/track-event';

const inviteSupplierUserSchema = Yup.object().shape({
  email: Yup.string().email('Ongeldig email').required('Vereist'),
});

export const InviteSupplierUserPage = () => {
  const navigate = useNavigate();
  const { supplier, refreshData } = useSupplier();
  const { i18n } = useTranslation();
  const [selectedRole, setSelectedRole] = useState('CarrierDispatcher');

  const roleOptions: ISimpleSelectItem[] = [
    { key: 'CarrierDispatcher', name: i18n('carrierPortal.users.roleDispatcher') },
    { key: 'CarrierDriver', name: i18n('carrierPortal.users.roleDriver') },
  ];

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={inviteSupplierUserSchema}
      onSubmit={async (values) => {
        try {
          await inviteCarrierUser(supplier.id, values.email, selectedRole);
          refreshData();
          trackEvent('supplier_user_invited', {
            supplier_id: supplier.id,
            role: selectedRole,
          });
          toast.success(i18n('carrierPortal.users.userInvited'));
          navigate('..');
        } catch (err: any) {
          captureException(err);
          toast.error(i18n('carrierPortal.users.couldNotInviteUser', { error: getDisplayError(err) }));
        }
      }}
    >
      {({ handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit} className="grid max-w-[520px] gap-4">
          <Card title={i18n('carrierPortal.users.inviteUser')}>
            <InputField labelText={i18n('carrierPortal.users.email')} type="email" name="email" />

            <div>
              <label className="label-text mb-1 block">{i18n('carrierPortal.users.role')}</label>
              <SimpleSelect
                items={roleOptions}
                selectedItem={roleOptions.find((r) => r.key === selectedRole) ?? roleOptions[0]}
                onSelect={(item) => {
                  if (item) {
                    setSelectedRole(item.key as string);
                  }
                }}
              />
            </div>
          </Card>

          <div className="flex gap-2">
            <Button
              type="submit"
              color="primary"
              isDisabled={isSubmitting}
              isLoading={isSubmitting}
              iconLeft={<PaperPlaneTiltIcon className="button-icon" />}
            >
              {i18n('carrierPortal.users.inviteUser')}
            </Button>

            <Button color="secondary" onTrigger={() => navigate('..')}>
              Annuleer
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
};
